import React, { useState } from 'react';
import './TemplateSelectionDialogueIn3D.scss';
import CancelButton from '../../UI/CancelButton/CancelButton';
import OKButton from '../../UI/OKButton/OKButton';

const templateSelectionDialogueIn3D = props => {
  const { templates, okHandler, cancelHandler } = props;
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <div className='DialogBox'>
      <p className='headerLabel'>Apply Background To:</p>
      <div className='templatePreviewContainer'>
        {templates.map((template, index) => (
          <div className='templatePreview' key={template.previewImageUrl}>
            <img
              className='templateImage'
              src={template.previewImageUrl}
              alt='template_preview'
            />
            <div>
              <input
                type='radio'
                id={template.previewImageUrl}
                name='imageSelector'
                value={index}
                checked={activeIndex == index}
                onChange={e => {
                  setActiveIndex(e.target.value);
                }}
              />
              <span className='ml-1 text-capitalize'>{template.material}</span>
            </div>
          </div>
        ))}
      </div>
      <CancelButton clickHandler={cancelHandler} />
      <OKButton clickHandler={() => okHandler(activeIndex)} />
    </div>
  );
};

export default templateSelectionDialogueIn3D;
